//Cognito authentication
export const ADD_COGNITO_AUTH = "auth.ADD";

export function updateCognito(authData) {
  return {
    type: ADD_COGNITO_AUTH,
    authData: authData,
  };
}
